import React, { useState } from "react";
import Modal from "react-bootstrap/esm/Modal";
import styled from "styled-components";

function EntryTutorialModal({
    showState,
    toggleInformationModal,
    getComponent,
    getTitle,
    pages
}) {
    const [page, setPage] = useState(1);

    const handleNextButtonClick = () => {
        if (page === pages) {
            toggleInformationModal();
            return setPage(1);
        }

        setPage((prevPage) => prevPage + 1);
    }

    return (
        <Modal
            className={"question-container"}
            show={showState}
            onHide={toggleInformationModal}
            backdrop="static"
            animation={false}
            centered
        >
            <div className="header text-centered">
                <Title>{getTitle(page)}</Title>
            </div>
            <div className="body">
                {getComponent(page)}
            </div>
            <Modal.Footer style={{ justifyContent: 'space-between' }}>
                <NextButton showButton={false} />
                <PageCount>{pages > 1 ? `${page}/${pages}` : null}</PageCount>
                <NextButton onClick={handleNextButtonClick} showButton={true} >
                    <span>Jasne,</span>
                    <span>rozumiem</span>
                </NextButton>
            </Modal.Footer>
        </Modal>
    );
}

export default EntryTutorialModal;

const NextButton = styled.div`
  background-image: url("/assets/front/img/edustrada/green-orange-button.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 115px;
  cursor: pointer;
  border-radius: 10px;
  text-align: center;
  padding: 5px 0;
  color: white;
  font-size: 17px;
  font-weight: bold;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  opacity: ${(props) => props.showButton ? 1 : 0};
  visibility: ${(props) => props.showButton ? 'visible' : 'hidden'};
`;

const PageCount = styled.div`
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #fff;
`

const Title = styled.span`
    text-decoration: underline;
`